/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

var _components = require('components');

var FeaturedArticleBlock = (function (_Component) {
	_inherits(FeaturedArticleBlock, _Component);

	function FeaturedArticleBlock() {
		_classCallCheck(this, FeaturedArticleBlock);

		_Component.apply(this, arguments);
	}

	FeaturedArticleBlock.prototype.render = function render() {
		var _classNames;

		var styles = require('./FeaturedArticleBlock.css');
		var baseClasses = _classnames2['default']((_classNames = {}, _classNames[styles.Base] = true, _classNames[this.props.className] = this.props.className, _classNames));

		return _react2['default'].createElement(
			'article',
			{ className: baseClasses },
			this.props.imageSrc && _react2['default'].createElement(
				'figure',
				{ className: styles.Figure },
				_react2['default'].createElement(
					_reactRouter.Link,
					{ className: styles.FigureLink, to: this.props.uri },
					_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + this.props.imageSrc })
				)
			),
			_react2['default'].createElement(
				'div',
				{ className: styles.ContentWrapper },
				this.props.specialSeries && _react2['default'].createElement(_components.HeaderTab, {
					className: styles.HeaderTab,
					icon: 'pot',
					title: this.props.specialSeries.name
				}),
				_react2['default'].createElement(_components.MetaBar, {
					author: this.props.author,
					authorURI: this.props.authorURI,
					categories: this.props.categories,
					postDate: this.props.postDate
				}),
				_react2['default'].createElement(
					'header',
					{ className: styles.Header },
					_react2['default'].createElement(
						'h1',
						{ className: styles.Title },
						_react2['default'].createElement(
							_reactRouter.Link,
							{ className: styles['Title--underlined'], to: this.props.uri },
							this.props.title
						)
					)
				),
				_react2['default'].createElement('div', { className: styles.Content, dangerouslySetInnerHTML: { __html: this.props.content } })
			)
		);
	};

	_createClass(FeaturedArticleBlock, null, [{
		key: 'propTypes',
		value: {
			categories: _react.PropTypes.array,
			imageSrc: _react.PropTypes.string,
			category: _react.PropTypes.string,
			categoryURI: _react.PropTypes.string,
			author: _react.PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.number]),
			authorURI: _react.PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.bool]),
			postDate: _react.PropTypes.string.isRequired,
			title: _react.PropTypes.string.isRequired,
			content: _react.PropTypes.string.isRequired,
			uri: _react.PropTypes.string.isRequired,
			className: _react.PropTypes.string,
			specialSeries: _react.PropTypes.object
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			imageSrc: 'https://placeholdit.imgix.net/~text?txtsize=72&txt=Featured Article&w=2000&h=1124',
			category: 'No Category',
			categoryURI: null,
			author: 'The Author',
			postDate: 'May 11, 1973',
			title: 'The Title',
			content: {},
			'uri': '/'
		},
		enumerable: true
	}]);

	return FeaturedArticleBlock;
})(_react.Component);

exports['default'] = FeaturedArticleBlock;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FeaturedArticleBlock/FeaturedArticleBlock.js
 ** module id = 678
 ** module chunks = 0
 **/